(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_logo_bar"] && !Shopify.designMode) return;
  try {
    
$('.logo-slide').slick({
    dots: false,
    infinite: true,
    autoplay:false,
    autoplaySpeed:1500,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  } catch(e) { console.error(e); }
})();
})();
